// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";
import PropTypes from "prop-types";

import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Button, MobileStepper, mobileStepperClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "DottedStepper";

const classes = {
  buttonActive: `${PREFIX}-buttonActive`,
};

const StyledMobileStepper = styled(MobileStepper)(({ theme: { palette } }) => ({
  [`&.${mobileStepperClasses.dotActive}`]: {
    backgroundColor: (props) => palette[props.color].dark,
    [`& .${classes.buttonActive}`]: {
      color: (props) => palette[props.color].dark,
    },
  },
}));

const DottedStepper = ({
  steps,
  activeStep,
  backButtonHandler,
  backButtonLabel,
  color,
  isBackButtonDisabled,
  isNextButtonDisabled,
  nextButtonHandler,
  nextButtonLabel,
  position,
  ...props
}) => {
  return (
    <StyledMobileStepper
      {...{ props }}
      variant="dots"
      steps={steps}
      activeStep={activeStep}
      position={position}
      color={color}
      backButton={
        <Button
          size="small"
          color={color}
          className={classes.buttonActive}
          onClick={backButtonHandler}
          disabled={isBackButtonDisabled(activeStep, steps)}
        >
          <KeyboardArrowLeft />
          {backButtonLabel}
        </Button>
      }
      nextButton={
        <Button
          size="small"
          type="submit"
          color={color}
          className={classes.buttonActive}
          onClick={nextButtonHandler}
          disabled={isNextButtonDisabled(activeStep, steps)}
        >
          {nextButtonLabel}
          <KeyboardArrowRight />
        </Button>
      }
    />
  );
};

DottedStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  backButtonHandler: PropTypes.func.isRequired,
  backButtonLabel: PropTypes.string,
  color: PropTypes.oneOf([
    "error",
    "info",
    "primary",
    "secondary",
    "success",
    "warning",
  ]),
  isBackButtonDisabled: PropTypes.func,
  isNextButtonDisabled: PropTypes.func,
  nextButtonHandler: PropTypes.func.isRequired,
  nextButtonLabel: PropTypes.string,
  position: PropTypes.oneOf(["bottom", "static", "top"]),
  steps: PropTypes.number.isRequired,
};

DottedStepper.defaultProps = {
  backButtonLabel: "Voltar",
  color: "secondary",
  isBackButtonDisabled: (activeStep) => activeStep === 0,
  isNextButtonDisabled: (activeStep, steps) => activeStep === steps - 1,
  nextButtonLabel: "Próximo",
  position: "static",
};

export default DottedStepper;
